module.exports = __webpack_public_path__ + "img/gratitude-journal_B095MB7VQ9.f4686130.jpg";